

































































































































































































import PdfContent from "../../PdfContent.vue";
import VueHtml2pdf from "../../VueHtml2pdf.vue";
import ControlsContainerMobile from "../controls-container/ControlsContainerMobile.vue";
import CertificateTreatment from "../../CertificateTreatment.vue";
import Vue from "vue";
import Component from "vue-class-component";
import {
  ShipmentCertificateModel,
  ShipmentCertificatesApi,
  TreatmentRequestCertificateModel,
  TreatmentRequestsApi,
  WebConfigsApi,
  WebConfigModel,
} from "../../../../apis";
import QrcodeVue from "qrcode.vue";
import moment from "moment-timezone";
@Component({
  components: {
    VueHtml2pdf,
    PdfContent,
    QrcodeVue,
    ControlsContainerMobile,
    CertificateTreatment,
  },
})
export default class CertificateTreatmentMobile extends Vue {
  contentRendered = false;
  progress = 0;
  registrationStr = '';
  generatingPdf = false;
  pdfDownloaded = false;
  controlValue = {
    showLayout: false,
    floatLayout: true,
    enableDownload: true,
    previewModal: true,
    paginateElementsByHeight: 1300,
    manualPagination: true,
    // filename: "Hee Hee",
    pdfQuality: 2,
    pdfFormat: "a3",
    pdfOrientation: "portrait",
    pdfContentWidth: "1000px",
  };
  isRed = true;
  isShowLogo = false;

  certificate: TreatmentRequestCertificateModel = Object.assign({});

  products = [];
  numberOfPallets = [];
  lotNumber = [];
  numberOfPackages = [];
  totalWeight = [];
  webConfig: any = {};
  condition = "";
  hasBackgroundImage = true;
  hasStamp = true;
  formatTimezone(time) {
    let offset = 0;
    if (this.certificate && this.certificate.locationTimeZone) {
      const now = new Date();
      const locationTime = now.toLocaleString("en-US", { timeZone: this.certificate.locationTimeZone });
      const subdate = new Date(locationTime);
      offset = Math.round((subdate.getTime() - now.getTime()) / 1000);
    }
    return moment(time).add(offset, "second").format("DD MMM YYYY");
  }
  async created() {
    this.$util.showLoading();
    try {
      const [rs, configRs] = await Promise.all([
        new TreatmentRequestsApi().viewCertificateTreatmentRequest({ id: this.$route.params.id }),
        new WebConfigsApi().getDefaultWebConfig()
      ]);
      this.certificate = rs.data.data;

      this.webConfig = configRs.data.data;
      this.products = this.certificate.weights;
      this.numberOfPallets = this.products.filter(prod => prod.numberOfPallets);
      this.lotNumber = this.products.filter(prod => prod.lotNumber);
      this.numberOfPackages = this.products.filter(prod => prod.numberOfPackages);
      this.totalWeight = this.products.filter(prod => prod.totalWeight);
      this.isShowLogo = this.certificate.isPallet;
      const conditionNo = this.certificate.conditionNo;
      if (this.isShowLogo) {
        switch (conditionNo) {
          case 3:
            this.condition = this.webConfig.condition3;
            break;
          case 2:
            this.condition = this.webConfig.condition2;
            break;
          default:
            this.condition = this.webConfig.condition1;
            break;
        }
      } else {
        const setPointConditions = [];
        if (this.certificate.setPointValue && this.certificate.setPointValue[0]) {
          setPointConditions.push(`${this.certificate.setPointValue[0].value}% O₂`);
        }
        if (this.certificate.setPointValue && this.certificate.setPointValue[1]) {
          setPointConditions.push(`${this.certificate.setPointValue[1].value}°C`);
        }
        this.condition = [...setPointConditions, `for at least ${this.certificate.treatmentTime} ${(this.certificate.treatmentFormat || '').toLocaleLowerCase()}`].join(", ");
      }

      switch (this.certificate.registrationNum) {
        case 3:
          this.registrationStr = !!this.certificate.registrationNo3 ? this.certificate.registrationNo3 : this.webConfig.rootRegistrationNo3;
          break;
        case 2:
          this.registrationStr = this.certificate.registrationNo2 ? this.certificate.registrationNo2 : this.webConfig.rootRegistrationNo2;
          break;
        default:
          this.registrationStr = this.certificate.registrationNo ? this.certificate.registrationNo : this.webConfig.rootRegistrationNo1;
          break;
      }
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }
  }
  formatInsect() {
    return !this.certificate.insectValue
      ? ""
      : this.lodash.join(
        this.lodash.uniq(
          this.certificate.insectValue.map((val) => val["name"])
        ),
        ", "
      );
  }
  getHref() {
    return window.location.href;
  }

  get showNumberOfPallets() {
    return (!this.lodash.isEmpty(this.numberOfPallets));
  }

  get showLotNumber() {
    return (!this.lodash.isEmpty(this.lotNumber));
  }

  get showNumberOfPackages() {
    return (!this.lodash.isEmpty(this.numberOfPackages));
  }

  get showTotalWeight() {
    return (!this.lodash.isEmpty(this.totalWeight));
  }

  get htmlToPdfOptions() {
    return {
      margin: 0,
      filename: this.certificate.number + ' Certificate',
      image: {
        type: "jpeg",
        quality: 0.98,
      },
      enableLinks: true,
      html2canvas: {
        scale: this.controlValue.pdfQuality,
        useCORS: true,
        width: 1000,
        height: 1414,
      },
      jsPDF: {
        unit: "in",
        format: this.controlValue.pdfFormat,
        orientation: this.controlValue.pdfOrientation,
      },
    };
  }
  async downloadPdf() {
    if (!(await this.validateControlValue())) return;
    (this.$refs.html2Pdf as any).generatePdf();
  }
  validateControlValue() {
    if (this.controlValue.pdfQuality > 2) {
      alert("pdf-quality value should only be 0 - 2");
      this.controlValue.pdfQuality = 2;
      return false;
    }
    if (!this.controlValue.paginateElementsByHeight) {
      alert("paginate-elements-by-height value cannot be empty");
      this.controlValue.paginateElementsByHeight = 1414;
      return false;
    }
    const paperSizes = [
      "a0",
      "a1",
      "a2",
      "a3",
      "a4",
      "letter",
      "legal",
      "a5",
      "a6",
      "a7",
      "a8",
      "a9",
      "a10",
    ];
    if (!paperSizes.includes(this.controlValue.pdfFormat)) {
      alert(`pdf-format value should only be ${paperSizes}`);
      this.controlValue.pdfFormat = "a4";
      return false;
    }
    if (!this.controlValue.pdfOrientation) {
      alert("pdf-orientation value cannot be empty");
      this.controlValue.pdfOrientation = "portrait";
      return false;
    }
    if (!this.controlValue.pdfContentWidth) {
      alert("pdf-content-width value cannot be empty");
      this.controlValue.pdfContentWidth = "800px";
      return false;
    }
    return true;
  }
  onProgress(progress) {
    this.progress = progress;
    console.log(`PDF generation progress: ${progress}%`);
  }
  startPagination() {
    console.log(`PDF has started pagination`);
  }
  hasPaginated() {
    console.log(`PDF has been paginated`);
  }
  async beforeDownload({ html2pdf, options, pdfContent }) {
    console.log(`On Before PDF Generation`);
    // await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
    // 	const totalPages = pdf.internal.getNumberOfPages()
    // 	for (let i = 1; i <= totalPages; i++) {
    // 		pdf.setPage(i)
    // 		pdf.setFontSize(10)
    // 		pdf.setTextColor(150)
    // 		pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
    // 	}
    // }).save()
  }
  hasDownloaded(blobPdf) {
    console.log(`PDF has downloaded yehey`);
    this.pdfDownloaded = true;
    console.log(blobPdf);
  }
  domRendered() {
    console.log("Dom Has Rendered");
    this.contentRendered = true;
  }
  onBlobGenerate(blob) {
    console.log(blob);
  }
  hasBackground(hasBackground) {
    this.hasBackgroundImage = hasBackground;
  }
}
